import downarrowimg from '../../../assets/images/chevron-down.svg'
import { Popover, OverlayTrigger } from 'react-bootstrap'
import Tags from '../../../components/UI/Tags/Tags'

import { useTranslation } from 'react-i18next'

export const ChartTableSortIcon = (data: any) => {
  const { t } = useTranslation('translation')
  return (
    <img
      src={downarrowimg}
      alt={t('collapsed')}
      className="chart-table-sort-icon"
    />
  )
}

const PopoverTagsComponent = (data: any) => {
  return (
    <Popover
      id="popover-basic-"
      {...data.popoverComponentProps}
      className="popover-tags-component"
    >
      <div
        data-tag="allowRowEvents"
        style={{
          color: '#07032B',
          overflow: 'hidden',
          textOverflow: 'ellipses',
        }}
        className="knowledge-tags d-flex flex-wrap align-items-center"
      >
        {data.tags &&
          data.tags.length > 0 &&
          data.tags.map((tag: string, index: number) => {
            return (
              <Tags
                key={tag + '_' + index}
                value={tag}
                label={tag}
                removeTagHandler={() => {}}
                hideDeleteOption
              />
            )
          })}
      </div>
    </Popover>
  )
}

export const TagsComponent = ({
  row,
  showAllTagsAtOnce,
  hideDeleteOption = true,
  removeTagHandler,
}: any) => {
  return (
    <>
      <div
        // data-tag='allowRowEvents'
        // style={{
        //   color: '#07032B',
        //   overflow: 'hidden',
        //   textOverflow: 'ellipses',
        // }}
        className="knowledge-tags d-flex flex-wrap align-items-center"
      >
        {showAllTagsAtOnce &&
          row.tags.map((tag: string, index: number) => {
            return (
              <Tags
                key={tag + '_' + index}
                value={tag}
                label={tag}
                removeTagHandler={removeTagHandler}
                hideDeleteOption={hideDeleteOption}
              />
            )
          })}

        {!showAllTagsAtOnce &&
          row.tags &&
          row.tags.length > 0 &&
          row.tags.slice(0, 3).map((tag: string, index: number) => {
            return (
              <Tags
                key={tag + '_' + index}
                value={tag}
                label={tag}
                removeTagHandler={removeTagHandler}
                hideDeleteOption={hideDeleteOption}
              />
            )
          })}
        {!showAllTagsAtOnce && row.tags && row.tags.length > 3 && (
          <OverlayTrigger
            trigger={['click']}
            placement="auto"
            overlay={d => (
              <PopoverTagsComponent
                popoverComponentProps={d}
                tags={row.tags.slice(3, row.tags.length)}
              />
            )}
          >
            <button className="btn more-tag p-0">+{row.tags.length - 3}</button>
          </OverlayTrigger>
        )}
      </div>
    </>
  )
}
